import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import restaurantService from '../../services/restaurantService';
import { BreadcrumbItem } from '../Breadcrumb/Breadcrumb';

/**
 * Breadcrumb for account pages (Your Orders, My Account, Address Book). Under a restaurant route
 * the trail starts with Restaurant › Menu, matching Order Details; on the global routes it starts
 * with Home.
 */
export function useAccountBreadcrumb(trail: BreadcrumbItem[]): BreadcrumbItem[] {
  const { appName } = useParams<{ appName: string }>();
  const [restaurantName, setRestaurantName] = useState('');

  useEffect(() => {
    if (!appName) return undefined;
    let cancelled = false;
    restaurantService
      .getRestaurant(appName)
      .then((res) => {
        if (!cancelled && res.restaurant?.restaurantName) {
          setRestaurantName(res.restaurant.restaurantName);
        }
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [appName]);

  if (!appName) return [{ label: 'Home', path: '/' }, ...trail];
  return [
    { label: restaurantName || 'Restaurant', path: `/restaurants/${appName}` },
    { label: 'Menu', path: `/restaurants/${appName}/menu` },
    ...trail.map((item) =>
      item.path && !item.path.startsWith('/restaurants/')
        ? { ...item, path: `/restaurants/${appName}${item.path}` }
        : item
    ),
  ];
}

export default useAccountBreadcrumb;
